if (!customElements.get('cart-gift-note')) {
  customElements.define(
    'cart-gift-note',
    class CartGiftNote extends HTMLElement {
      constructor() {
        super();

        this.maxLines = 5;
        this.checkbox = this.querySelector('[data-gift-checkbox]');
        this.noteWrapper = this.querySelector('[data-gift-note-wrapper]');
        this.textarea = this.querySelector('[data-gift-note-textarea]');

        const sendUpdate = debounce((event) => {
          const isGift = !!(this.checkbox && this.checkbox.checked);
          const body = JSON.stringify({
            attributes: {
              'Is Gift': isGift ? 'Yes' : '',
              'Gift Note': isGift && this.textarea ? this.textarea.value : '',
            },
          });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() => {
            if (window.CartPerformance) {
              CartPerformance.measureFromEvent('gift-note-update:user-action', event);
            }
          });
        }, ON_CHANGE_DEBOUNCE_TIMER);

        const enforceLineLimit = () => {
          if (!this.textarea) return;
          const lines = this.textarea.value.split('\n');
          if (lines.length > this.maxLines) {
            const selectionEnd = this.textarea.selectionEnd;
            const overflow = lines.length - this.maxLines;
            this.textarea.value = lines.slice(0, this.maxLines).join('\n');
            if (typeof selectionEnd === 'number') {
              const newPos = Math.max(0, selectionEnd - overflow);
              this.textarea.setSelectionRange(newPos, newPos);
            }
          }
        };

        if (this.checkbox) {
          this.checkbox.addEventListener('change', (event) => {
            if (this.noteWrapper) this.noteWrapper.hidden = !this.checkbox.checked;
            sendUpdate(event);
          });
        }

        if (this.textarea) {
          this.textarea.addEventListener('input', (event) => {
            enforceLineLimit();
            sendUpdate(event);
          });
        }
      }
    }
  );
}
